var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i',{staticClass:"icon-bg",style:(_vm.styles)},[_c('feather',{style:("color:" + _vm.icon.color + ";"),attrs:{"type":_vm.icon.type,"size":_vm.icon.size}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }